import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import InstallPrompt from "@/components/InstallPrompt";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AuthProvider } from "@/lib/auth";
import Home from "@/pages/Home";
import NewMatch from "@/pages/NewMatch";
import LiveScoring from "@/pages/LiveScoring";
import MatchView from "@/pages/MatchView";
import History from "@/pages/History";
import Stats from "@/pages/Stats";
import Teams from "@/pages/Teams";
import Spectator from "@/pages/Spectator";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AdminUsers from "@/pages/AdminUsers";
import ChangePassword from "@/pages/ChangePassword";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route
              path="/watch/:id"
              element={
                <div className="min-h-screen bg-background">
                  <Spectator />
                </div>
              }
            />
            <Route
              path="*"
              element={
                <Layout>
                  <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/" element={<Home />} />
                    <Route path="/match/:id" element={<MatchView />} />
                    <Route path="/history" element={<History />} />
                    <Route
                      path="/teams"
                      element={
                        <ProtectedRoute roles={["admin", "scorer"]}>
                          <Teams />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/new"
                      element={
                        <ProtectedRoute roles={["admin", "scorer"]}>
                          <NewMatch />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/match/:id/score"
                      element={
                        <ProtectedRoute roles={["admin", "scorer"]}>
                          <LiveScoring />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/stats"
                      element={
                        <ProtectedRoute>
                          <Stats />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/change-password"
                      element={
                        <ProtectedRoute>
                          <ChangePassword />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/admin/users"
                      element={
                        <ProtectedRoute roles={["admin"]}>
                          <AdminUsers />
                        </ProtectedRoute>
                      }
                    />
                  </Routes>
                </Layout>
              }
            />
          </Routes>
          <InstallPrompt />
          <Toaster theme="dark" position="top-right" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
